export const SUPPLY_TYPES = [
  "Local Supply",
  "Interstate Supply",
  "International Supply",
  "Sea Freight Restock",
  "Air Freight Restock",
  "Sea Freight Back Order",
  "Air Freight Backorder",
];

export function supplyTagClass(t) {
  const map = {
    "Local Supply": "bg-emerald-50 text-emerald-700 border-emerald-200",
    "Interstate Supply": "bg-teal-50 text-teal-700 border-teal-200",
    "International Supply": "bg-violet-50 text-violet-700 border-violet-200",
    "Sea Freight Restock": "bg-blue-50 text-blue-700 border-blue-200",
    "Air Freight Restock": "bg-sky-50 text-sky-700 border-sky-200",
    "Sea Freight Back Order": "bg-indigo-50 text-indigo-700 border-indigo-200",
    "Air Freight Backorder": "bg-amber-50 text-amber-700 border-amber-200",
  };
  return map[t] || "bg-slate-100 text-slate-600 border-slate-200";
}

export const ROLL_EXPORT_COLUMNS = [
  "SKU", "Batch", "Brand", "Series", "Product", "Current Length (m)",
  "Initial Length (m)", "Width (m)", "Location", "Manufacturing Date", "Expiry Date", "Status",
];

export const PER_UNIT_EXPORT_COLUMNS = [
  "SKU", "Brand", "Series", "Product", "Count", "Low Stock Threshold", "Location", "Cost Per Unit", "Price Per Unit",
];

import Papa from "papaparse";

export function downloadCsv(filename, columns, dataRows) {
  const csv = Papa.unparse({ fields: columns, data: dataRows });
  const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
